import { useEffect, useRef } from "react";

interface PdfFrameProps {
  src: string;
  title: string;
  className?: string;
}

/** Loads via location.replace, not the src attribute, so Back on Chromium doesn't pop the iframe's navigation first. */
export function PdfFrame({ src, title, className }: PdfFrameProps) {
  const ref = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const win = ref.current?.contentWindow;
    if (!win) return;
    win.location.replace(src);
  }, [src]);

  return <iframe ref={ref} title={title} className={className} />;
}
